import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material';
import { AuthProvider } from './context/AuthContext';
import { WebSocketProvider } from './context/WebSocketContext';
import { MSALWrapper } from './components/auth/MSALWrapper';
import AppRoutes from './routes';
import AuthInitializer from './components/auth/AuthInitializer';
import ConfigInitializer from './components/config/ConfigInitializer';
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
        size: 'small',
      },
    },
    MuiButton: {
      defaultProps: {
        size: 'medium',
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
});

const App = () => {
  return (
    <ConfigInitializer>
      <MSALWrapper>
        <AuthProvider>
          <WebSocketProvider>
            <ThemeProvider theme={theme}>
            <AuthInitializer>
              <AppRoutes />
            </AuthInitializer>
            </ThemeProvider>
          </WebSocketProvider>
        </AuthProvider>
      </MSALWrapper>
    </ConfigInitializer>
  );
};

export default App;
